import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7df7fe5d = () => interopDefault(import('../pages/about-us.vue' /* webpackChunkName: "pages/about-us" */))
const _36557bf4 = () => interopDefault(import('../pages/careers.vue' /* webpackChunkName: "pages/careers" */))
const _4b75c193 = () => interopDefault(import('../pages/content-lobby.vue' /* webpackChunkName: "pages/content-lobby" */))
const _2959c244 = () => interopDefault(import('../pages/cypress.vue' /* webpackChunkName: "pages/cypress" */))
const _31f0b9e6 = () => interopDefault(import('../pages/fix.vue' /* webpackChunkName: "pages/fix" */))
const _5cd4e197 = () => interopDefault(import('../pages/job-opportunity/index.vue' /* webpackChunkName: "pages/job-opportunity/index" */))
const _95f3dfd0 = () => interopDefault(import('../pages/jobs/index.vue' /* webpackChunkName: "pages/jobs/index" */))
const _3ce9556e = () => interopDefault(import('../pages/login-external.vue' /* webpackChunkName: "pages/login-external" */))
const _0ce45471 = () => interopDefault(import('../pages/ping.vue' /* webpackChunkName: "pages/ping" */))
const _2e50b29c = () => interopDefault(import('../pages/portfolio/index.vue' /* webpackChunkName: "pages/portfolio/index" */))
const _1df30b4a = () => interopDefault(import('../pages/redirect.vue' /* webpackChunkName: "pages/redirect" */))
const _2f39719e = () => interopDefault(import('../pages/request-testimonials.vue' /* webpackChunkName: "pages/request-testimonials" */))
const _742b4c3e = () => interopDefault(import('../pages/sales-compensation-2022.vue' /* webpackChunkName: "pages/sales-compensation-2022" */))
const _34a687bd = () => interopDefault(import('../pages/sales-directory.vue' /* webpackChunkName: "pages/sales-directory" */))
const _67ada5ac = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _0fbd65e1 = () => interopDefault(import('../pages/testing.vue' /* webpackChunkName: "pages/testing" */))
const _4d22cb6c = () => interopDefault(import('../pages/control-panel/parsers.vue' /* webpackChunkName: "pages/control-panel/parsers" */))
const _12ed7474 = () => interopDefault(import('../pages/integration/crm.vue' /* webpackChunkName: "pages/integration/crm" */))
const _d563955a = () => interopDefault(import('../pages/jobs/about.vue' /* webpackChunkName: "pages/jobs/about" */))
const _3c3c23a7 = () => interopDefault(import('../pages/jobs/matching.vue' /* webpackChunkName: "pages/jobs/matching" */))
const _15265288 = () => interopDefault(import('../pages/jobs/my-matches.vue' /* webpackChunkName: "pages/jobs/my-matches" */))
const _7a799132 = () => interopDefault(import('../pages/jobs/profile/index.vue' /* webpackChunkName: "pages/jobs/profile/index" */))
const _7a6a0728 = () => interopDefault(import('../pages/jobs/welcome.vue' /* webpackChunkName: "pages/jobs/welcome" */))
const _8f04eb18 = () => interopDefault(import('../pages/portfolio/testify.vue' /* webpackChunkName: "pages/portfolio/testify" */))
const _5441c142 = () => interopDefault(import('../pages/profile/referral.vue' /* webpackChunkName: "pages/profile/referral" */))
const _0fd36270 = () => interopDefault(import('../pages/profile/settings.vue' /* webpackChunkName: "pages/profile/settings" */))
const _b2b5b234 = () => interopDefault(import('../pages/profile/settings/account.vue' /* webpackChunkName: "pages/profile/settings/account" */))
const _0b1ff68a = () => interopDefault(import('../pages/profile/settings/appearance.vue' /* webpackChunkName: "pages/profile/settings/appearance" */))
const _5498c13e = () => interopDefault(import('../pages/profile/settings/notifications.vue' /* webpackChunkName: "pages/profile/settings/notifications" */))
const _764d9020 = () => interopDefault(import('../pages/referral/promotion.vue' /* webpackChunkName: "pages/referral/promotion" */))
const _ea70589e = () => interopDefault(import('../pages/search/image-preview/index.vue' /* webpackChunkName: "pages/search/image-preview/index" */))
const _d3a551b4 = () => interopDefault(import('../pages/war-room/posts/index.vue' /* webpackChunkName: "pages/war-room/posts/index" */))
const _f658d5f8 = () => interopDefault(import('../pages/war-room/products.vue' /* webpackChunkName: "pages/war-room/products" */))
const _76960080 = () => interopDefault(import('../pages/war-room/categories/posts.vue' /* webpackChunkName: "pages/war-room/categories/posts" */))
const _0308bff4 = () => interopDefault(import('../pages/war-room/posts/new.vue' /* webpackChunkName: "pages/war-room/posts/new" */))
const _2403672c = () => interopDefault(import('../pages/war-room/posts/tab/index.vue' /* webpackChunkName: "pages/war-room/posts/tab/index" */))
const _b1c95f60 = () => interopDefault(import('../pages/war-room/profile/edit.vue' /* webpackChunkName: "pages/war-room/profile/edit" */))
const _78b725e3 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _bb10e43e = () => interopDefault(import('../pages/war-room/posts/edit/_postSlug.vue' /* webpackChunkName: "pages/war-room/posts/edit/_postSlug" */))
const _0951616c = () => interopDefault(import('../pages/war-room/posts/tab/_tab.vue' /* webpackChunkName: "pages/war-room/posts/tab/_tab" */))
const _499738b2 = () => interopDefault(import('../pages/jobs/opportunities/_opportunitySlug.vue' /* webpackChunkName: "pages/jobs/opportunities/_opportunitySlug" */))
const _7becc427 = () => interopDefault(import('../pages/jobs/vacancies/_vacancySlug.vue' /* webpackChunkName: "pages/jobs/vacancies/_vacancySlug" */))
const _b4e6e5c4 = () => interopDefault(import('../pages/war-room/posts/_postSlug.vue' /* webpackChunkName: "pages/war-room/posts/_postSlug" */))
const _61f64521 = () => interopDefault(import('../pages/war-room/posts/_postSlug/index.vue' /* webpackChunkName: "pages/war-room/posts/_postSlug/index" */))
const _45b81136 = () => interopDefault(import('../pages/war-room/posts/_postSlug/comments/_commentId.vue' /* webpackChunkName: "pages/war-room/posts/_postSlug/comments/_commentId" */))
const _522cc5a2 = () => interopDefault(import('../pages/war-room/profile/_username/index.vue' /* webpackChunkName: "pages/war-room/profile/_username/index" */))
const _d00d5f4e = () => interopDefault(import('../pages/war-room/categories/_categorySlug/posts.vue' /* webpackChunkName: "pages/war-room/categories/_categorySlug/posts" */))
const _0afc3790 = () => interopDefault(import('../pages/war-room/profile/_username/badges.vue' /* webpackChunkName: "pages/war-room/profile/_username/badges" */))
const _71cdceda = () => interopDefault(import('../pages/war-room/topics/_topicSlug/posts.vue' /* webpackChunkName: "pages/war-room/topics/_topicSlug/posts" */))
const _69003bed = () => interopDefault(import('../pages/flex-challenge/_page.vue' /* webpackChunkName: "pages/flex-challenge/_page" */))
const _991bb9a0 = () => interopDefault(import('../pages/job-opportunity/_hashId/index.vue' /* webpackChunkName: "pages/job-opportunity/_hashId/index" */))
const _eb3d6e52 = () => interopDefault(import('../pages/portfolio/_slug/index.vue' /* webpackChunkName: "pages/portfolio/_slug/index" */))
const _62a3e533 = () => interopDefault(import('../pages/review/_step.vue' /* webpackChunkName: "pages/review/_step" */))
const _bc625596 = () => interopDefault(import('../pages/search/_category.vue' /* webpackChunkName: "pages/search/_category" */))
const _40afb894 = () => interopDefault(import('../pages/universities/_universitySlug.vue' /* webpackChunkName: "pages/universities/_universitySlug" */))
const _5f7b6a8c = () => interopDefault(import('../pages/job-opportunity/_hashId/auth.vue' /* webpackChunkName: "pages/job-opportunity/_hashId/auth" */))
const _de72a404 = () => interopDefault(import('../pages/job-opportunity/_hashId/contact.vue' /* webpackChunkName: "pages/job-opportunity/_hashId/contact" */))
const _5b003e1a = () => interopDefault(import('../pages/portfolio/_slug/connections.vue' /* webpackChunkName: "pages/portfolio/_slug/connections" */))
const _191cb18d = () => interopDefault(import('../pages/portfolio/_slug/preview.vue' /* webpackChunkName: "pages/portfolio/_slug/preview" */))
const _52c17def = () => interopDefault(import('../pages/portfolio/_slug/testify.vue' /* webpackChunkName: "pages/portfolio/_slug/testify" */))
const _565edc78 = () => interopDefault(import('../pages/landing/_.vue' /* webpackChunkName: "pages/landing/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'link link--active',
  linkExactActiveClass: 'link link--exact',
  scrollBehavior,

  routes: [{
    path: "/about-us",
    component: _7df7fe5d,
    name: "about-us"
  }, {
    path: "/careers",
    component: _36557bf4,
    name: "careers"
  }, {
    path: "/content-lobby",
    component: _4b75c193,
    name: "content-lobby"
  }, {
    path: "/cypress",
    component: _2959c244,
    name: "cypress"
  }, {
    path: "/fix",
    component: _31f0b9e6,
    name: "fix"
  }, {
    path: "/job-opportunity",
    component: _5cd4e197,
    name: "job-opportunity"
  }, {
    path: "/jobs",
    component: _95f3dfd0,
    name: "jobs"
  }, {
    path: "/login-external",
    component: _3ce9556e,
    name: "login-external"
  }, {
    path: "/ping",
    component: _0ce45471,
    name: "ping"
  }, {
    path: "/portfolio",
    component: _2e50b29c,
    name: "portfolio"
  }, {
    path: "/redirect",
    component: _1df30b4a,
    name: "redirect"
  }, {
    path: "/request-testimonials",
    component: _2f39719e,
    name: "request-testimonials"
  }, {
    path: "/sales-compensation-2022",
    component: _742b4c3e,
    name: "sales-compensation-2022"
  }, {
    path: "/sales-directory",
    component: _34a687bd,
    name: "sales-directory"
  }, {
    path: "/search",
    component: _67ada5ac,
    name: "search"
  }, {
    path: "/testing",
    component: _0fbd65e1,
    name: "testing"
  }, {
    path: "/control-panel/parsers",
    component: _4d22cb6c,
    name: "control-panel-parsers"
  }, {
    path: "/integration/crm",
    component: _12ed7474,
    name: "integration-crm"
  }, {
    path: "/jobs/about",
    component: _d563955a,
    name: "jobs-about"
  }, {
    path: "/jobs/matching",
    component: _3c3c23a7,
    name: "jobs-matching"
  }, {
    path: "/jobs/my-matches",
    component: _15265288,
    name: "jobs-my-matches"
  }, {
    path: "/jobs/profile",
    component: _7a799132,
    name: "jobs-profile"
  }, {
    path: "/jobs/welcome",
    component: _7a6a0728,
    name: "jobs-welcome"
  }, {
    path: "/portfolio/testify",
    component: _8f04eb18,
    name: "portfolio-testify"
  }, {
    path: "/profile/referral",
    component: _5441c142,
    name: "profile-referral"
  }, {
    path: "/profile/settings",
    component: _0fd36270,
    name: "profile-settings",
    children: [{
      path: "account",
      component: _b2b5b234,
      name: "profile-settings-account"
    }, {
      path: "appearance",
      component: _0b1ff68a,
      name: "profile-settings-appearance"
    }, {
      path: "notifications",
      component: _5498c13e,
      name: "profile-settings-notifications"
    }]
  }, {
    path: "/referral/promotion",
    component: _764d9020,
    name: "referral-promotion"
  }, {
    path: "/search/image-preview",
    component: _ea70589e,
    name: "search-image-preview"
  }, {
    path: "/war-room/posts",
    component: _d3a551b4,
    name: "war-room-posts"
  }, {
    path: "/war-room/products",
    component: _f658d5f8,
    name: "war-room-products"
  }, {
    path: "/war-room/categories/posts",
    component: _76960080,
    name: "war-room-categories-posts"
  }, {
    path: "/war-room/posts/new",
    component: _0308bff4,
    name: "war-room-posts-new"
  }, {
    path: "/war-room/posts/tab",
    component: _2403672c,
    name: "war-room-posts-tab"
  }, {
    path: "/war-room/profile/edit",
    component: _b1c95f60,
    name: "war-room-profile-edit"
  }, {
    path: "/",
    component: _78b725e3,
    name: "index"
  }, {
    path: "/war-room/posts/edit/:postSlug",
    component: _bb10e43e,
    name: "war-room-posts-edit-postSlug"
  }, {
    path: "/war-room/posts/tab/:tab",
    component: _0951616c,
    name: "war-room-posts-tab-tab"
  }, {
    path: "/jobs/opportunities/:opportunitySlug?",
    component: _499738b2,
    name: "jobs-opportunities-opportunitySlug"
  }, {
    path: "/jobs/vacancies/:vacancySlug?",
    component: _7becc427,
    name: "jobs-vacancies-vacancySlug"
  }, {
    path: "/war-room/posts/:postSlug?",
    component: _b4e6e5c4,
    children: [{
      path: "",
      component: _61f64521,
      name: "war-room-posts-postSlug"
    }, {
      path: "comments/:commentId?",
      component: _45b81136,
      name: "war-room-posts-postSlug-comments-commentId"
    }]
  }, {
    path: "/war-room/profile/:username",
    component: _522cc5a2,
    name: "war-room-profile-username"
  }, {
    path: "/war-room/categories/:categorySlug?/posts",
    component: _d00d5f4e,
    name: "war-room-categories-categorySlug-posts"
  }, {
    path: "/war-room/profile/:username?/badges",
    component: _0afc3790,
    name: "war-room-profile-username-badges"
  }, {
    path: "/war-room/topics/:topicSlug?/posts",
    component: _71cdceda,
    name: "war-room-topics-topicSlug-posts"
  }, {
    path: "/flex-challenge/:page?",
    component: _69003bed,
    name: "flex-challenge-page"
  }, {
    path: "/job-opportunity/:hashId",
    component: _991bb9a0,
    name: "job-opportunity-hashId"
  }, {
    path: "/portfolio/:slug",
    component: _eb3d6e52,
    name: "portfolio-slug"
  }, {
    path: "/review/:step?",
    component: _62a3e533,
    name: "review-step"
  }, {
    path: "/search/:category",
    component: _bc625596,
    name: "search-category"
  }, {
    path: "/universities/:universitySlug?",
    component: _40afb894,
    name: "universities-universitySlug"
  }, {
    path: "/job-opportunity/:hashId?/auth",
    component: _5f7b6a8c,
    name: "job-opportunity-hashId-auth"
  }, {
    path: "/job-opportunity/:hashId?/contact",
    component: _de72a404,
    name: "job-opportunity-hashId-contact"
  }, {
    path: "/portfolio/:slug/connections",
    component: _5b003e1a,
    name: "portfolio-slug-connections"
  }, {
    path: "/portfolio/:slug/preview",
    component: _191cb18d,
    name: "portfolio-slug-preview"
  }, {
    path: "/portfolio/:slug/testify",
    component: _52c17def,
    name: "portfolio-slug-testify"
  }, {
    path: "/landing/*",
    component: _565edc78,
    name: "landing-all"
  }, {
    path: "/portfolio/",
    alias: "/p/"
  }, {
    path: "/portfolio/:slug",
    alias: "/p/:slug"
  }, {
    path: "/portfolio/testify",
    alias: "/p/testify"
  }, {
    path: "/portfolio/:slug/testify",
    alias: "/p/:slug/testify"
  }, {
    path: "/portfolio/:slug/preview",
    alias: "/p/:slug/preview"
  }, {
    path: "/portfolio/:slug/connections",
    alias: "/p/:slug/connections"
  }, {
    path: "/onboarding",
    redirect: "/simplified-onboarding/\\?onboarding"
  }, {
    path: "/onboarding/(.*)",
    redirect: "/simplified-onboarding/\\?onboarding"
  }, {
    path: "/onboarding-v3",
    redirect: "/simplified-onboarding/\\?onboarding"
  }, {
    path: "/onboarding-v3/(.*)",
    redirect: "/simplified-onboarding/\\?onboarding"
  }, {
    path: "/onboarding-intro",
    redirect: "/simplified-onboarding/\\?onboarding"
  }, {
    path: "/war-room/onboarding",
    redirect: "/simplified-onboarding/\\?onboarding"
  }, {
    path: "/war-room/onboarding/(.*)",
    redirect: "/simplified-onboarding/\\?onboarding"
  }, {
    path: "/b2c/",
    redirect: "/simplified-onboarding/\\?onboarding"
  }, {
    path: "/b2c/(.*)",
    redirect: "/simplified-onboarding/\\?onboarding"
  }, {
    path: "/jobs/profile/update(.*)",
    redirect: "/simplified-onboarding/"
  }, {
    path: "/connections/sync",
    redirect: "/simplified-onboarding/connections-sync"
  }, {
    path: "connections/contacts",
    redirect: "/simplified-onboarding/connections"
  }, {
    path: "/my-portfolio",
    redirect: "/performance-index/"
  }, {
    path: "/my-portfolio/onboarding",
    redirect: "/performance-index/onboarding"
  }, {
    path: "/my-portfolio/deals/:id",
    redirect: "/performance-index/deals/:id"
  }, {
    path: "/my-portfolio/quarters/:id",
    redirect: "/performance-index/quarters/:id"
  }, {
    path: "/my-portfolio/onboarding",
    redirect: "/performance-index/onboarding"
  }, {
    path: "/profile/new-settings",
    redirect: "/profile/settings/account"
  }, {
    path: "/profile/new-settings/account",
    redirect: "/profile/settings/account"
  }, {
    path: "/profile/new-settings/appearance",
    redirect: "/profile/settings/appearance"
  }, {
    path: "/profile/new-settings/notifications",
    redirect: "/profile/settings/notifications"
  }, {
    path: "/opportunities",
    redirect: "/"
  }, {
    path: "/opportunities/(.*)",
    redirect: "/"
  }, {
    path: "/subscription-tos",
    redirect: "/"
  }, {
    path: "/chrome-extension",
    redirect: "/"
  }, {
    path: "/lp/mentor",
    redirect: "https://bravado.co/lp/learn/techsalesu/"
  }, {
    path: "/lp/uws-mentorship",
    redirect: "https://bravado.co/lp/learn/techsalesu/"
  }, {
    path: "/why-testimonials",
    redirect: "/"
  }, {
    path: "/ads",
    redirect: "/"
  }, {
    path: "/customers/:slug",
    redirect: "/testimonials/:slug"
  }, {
    path: "/tos",
    redirect: "https://info.bravado.co/bravado-network-terms-of-service-for-users"
  }, {
    path: "/privacy",
    redirect: "https://info.bravado.co/privacy-policy"
  }, {
    path: "/copyright",
    redirect: "https://info.bravado.co/about"
  }, {
    path: "/academy/techsalesu",
    redirect: "https://bravado.co/lp/learn/techsalesu/"
  }, {
    path: "/landing/sales-jobs",
    redirect: "https://bravado.co/lp/jobs/open-roles-list"
  }, {
    path: "/war-room",
    redirect: "/war-room/posts/tab/my_feed"
  }, {
    path: "/war-room/posts",
    redirect: "/war-room/posts/tab/my_feed"
  }, {
    path: "/war-room/linkedin",
    redirect: "/war-room/posts/tab/my_feed"
  }, {
    path: "/community",
    redirect: "/war-room/posts/tab/my_feed"
  }, {
    path: "/feed/(.*)",
    redirect: "/war-room/posts/tab/my_feed"
  }, {
    path: "/war-room/annie-duke-event/",
    redirect: "/war-room/posts/bravado-member-exclusive-event-with-annie-duke"
  }, {
    path: "/techsalesu",
    redirect: "https://bravado.co/lp/learn/techsalesu/"
  }, {
    path: "/salaries",
    redirect: "/salaries/"
  }, {
    path: "/members",
    redirect: "/war-room/posts/tab/my_feed"
  }, {
    path: "/directory/:slug",
    redirect: "/sales-directory\\?prefix\\=:slug\\&page\\=1"
  }, {
    path: "/portfolio/:slug",
    redirect: "/p/:slug"
  }, {
    path: "/p",
    redirect: "/portfolio"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
